// src/pages/admin/EditUser.jsx
import { useEffect, useState, useContext } from "react";
import {
  Box,
  Heading,
  Input,
  Button,
  VStack,
  Field,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AuthContext from "../../context/AuthContext";
import { toaster } from "../../components/ui/toaster";

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user: currentUser } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  // 🔹 Load user data
  useEffect(() => {
    if (!currentUser?.token) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/users/${id}`, {
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      })
      .then((res) => {
        const { firstName, lastName, email } = res.data;
        setForm({ firstName, lastName, email, password: "" });
      })
      .catch(() => {
        toaster.create({
          title: "Benutzer konnte nicht geladen werden",
          type: "error",
        });
        navigate("/admin/benutzerverwaltung");
      })
      .finally(() => setLoading(false));
  }, [id, currentUser, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔹 Save changes
  const handleSubmit = async () => {
    if (!form.firstName || !form.lastName || !form.email) {
      toaster.create({
        title: "Pflichtfelder fehlen",
        type: "warning",
      });
      return;
    }

    const payload = {
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
    };

    // only send password if filled
    if (form.password) {
      payload.password = form.password;
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/users/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${currentUser.token}`,
          },
        }
      );

      toaster.create({
        title: "Benutzer erfolgreich aktualisiert",
        type: "success",
      });

      navigate("/admin/benutzerverwaltung");
    } catch (err) {
      toaster.create({
        title: "Fehler beim Speichern",
        description: err.response?.data || "Serverfehler",
        type: "error",
      });
    }
  };

  if (loading) {
    return <Box p={8}>Lade Benutzer…</Box>;
  }

  return (
    <Box maxW="lg" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={6}>
        Benutzer bearbeiten
      </Heading>

      <VStack spacing={4}>
        <Field.Root>
          <Field.Label>Vorname</Field.Label>
          <Input
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
          />
        </Field.Root>

        <Field.Root>
          <Field.Label>Nachname</Field.Label>
          <Input
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
          />
        </Field.Root>

        <Field.Root>
          <Field.Label>E-Mail</Field.Label>
          <Input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
          />
        </Field.Root>

        <Field.Root>
          <Field.Label>Neues Passwort (optional)</Field.Label>
          <Input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            placeholder="leer lassen, um es nicht zu ändern"
          />
        </Field.Root>

        <Button colorScheme="blue" w="full" mt={4} onClick={handleSubmit}>
          Speichern
        </Button>

        <Button
          variant="ghost"
          w="full"
          onClick={() => navigate("/admin/benutzerverwaltung")}
        >
          Abbrechen
        </Button>
      </VStack>
    </Box>
  );
}